import { render, staticRenderFns } from "./dictionarySelect.vue?vue&type=template&id=89fcb358"
import script from "./dictionarySelect.vue?vue&type=script&lang=js"
export * from "./dictionarySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports